<template>
  <div>
    <PageHeading
        :default-heading="pageHeader()"
        :edit-heading="pageHeader()"
      />
    <form
      novalidate="novalidate"
      @submit.prevent
    >
      <div class="pvd-container container-divider">
        <p>
          Don't close this page while {{ idVerificationName() }} is uploading
          their driver's license or passport. Click Finished with ID check once
          they're done.
        </p>
        <br>
        <p>If they haven't received a text, click Resend a new SMS link.</p>
        <br>
        <p>
          <u>
            <a id="resend-id-link">
              <router-link to="/trust-doc-verify-resend-sms">Resend a new SMS link</router-link>
            </a>
          </u>
        </p>
      </div>
      <NavigationComponent @next-action="handleWidgetSubmit" />
    </form>
  </div>
</template>
<script>
import utilityFunctions from '../mixins/utility';
import PageHeading from '../components/PageHeading.vue';
import validationHelper from '../mixins/validationHelper';
import widgetHelper from '../mixins/widgetHelper';
import dataHelper from '../mixins/dataHelper';
import dataSanitize from '../mixins/dataSanitize';
import pageNavigationHelper from '../mixins/pageNavigationHelper';
import NavigationComponent from '../components/NavigationComponent.vue';

export default {
  name: 'TrustDocVerifyWait',
  components: {
    NavigationComponent,
    PageHeading,
  },
  mixins: [
    utilityFunctions,
    validationHelper,
    widgetHelper,
    dataHelper,
    dataSanitize,
    pageNavigationHelper,
  ],
  mounted() {
    this.$store.commit('currentState/updateField', { path: 'stateName', value: 'trust-doc-verify-wait' });
  },
  methods: {
    pageHeader() {
      const { currentUserIndex } = this.getInstanceData().currentState;
      const { formData } = this.getInstanceData();
      if (Object.hasOwn(this.getInstanceData().currentState, 'currentUserIndex') && Number.isInteger(this.getInstanceData().currentState.currentUserIndex)) {
        return `${formData.additionalUsers[currentUserIndex]?.firstName} ${formData.additionalUsers[currentUserIndex]?.lastName}`.concat(' needs to finish their ID verification');
      }
      return `${formData.primaryUser?.firstName} ${formData.primaryUser?.lastName}`.concat(' needs to finish their ID verification');
    },
    idVerificationName() {
      const { currentUserIndex } = this.getInstanceData().currentState;
      const { formData } = this.getInstanceData();
      if (Object.hasOwn(this.getInstanceData().currentState, 'currentUserIndex') && Number.isInteger(this.getInstanceData().currentState.currentUserIndex)) {
        return `${formData.additionalUsers[currentUserIndex]?.firstName} ${formData.additionalUsers[currentUserIndex]?.lastName}`;
      }
      return `${formData.primaryUser?.firstName} ${formData.primaryUser?.lastName}`;
    },
    maskedPhoneNumber() {
      const { currentUserIndex } = this.getInstanceData().currentState;
      const { formData } = this.getInstanceData();
      const phoneNumber = Object.hasOwn(this.getInstanceData().currentState, 'currentUserIndex') && Number.isInteger(this.getInstanceData().currentState.currentUserIndex) ? formData.additionalUsers[currentUserIndex]?.dayPhone : formData.primaryUser?.dayPhone;
      return '***-***-'.concat(phoneNumber.replace(/\D/g, '').slice(-4));
    },
  },
  beforeDestroy() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  },
};
</script>

<style scoped>
.top-margin-zero {
  margin-top: 0;
}
#resend-id-link {
  color: black;
}
</style>
